function Option({ title, image }) {
	return (
		<div className="group flex w-[132px] flex-col justify-start gap-2 lg:w-[188px] lg:gap-3">
			<div className="relative flex transform justify-center rounded bg-grey-200 py-6 transition duration-500 group-hover:bg-red">
				<div className="absolute z-0 flex h-[68px] w-[68px] transform justify-center bg-black transition duration-500 group-hover:scale-110" />
				{image && (
					<img
						src={image}
						alt={title}
						width="48"
						height="48"
						className="z-10 m-2.5"
					/>
				)}
			</div>
			<span className="text-xs font-semibold leading-5 text-black lg:text-center lg:text-sm lg:leading-6">
				{title}
			</span>
		</div>
	);
}

export default Option;
